const colors = {
  FOCUS_BLUE: '#1379D8',
  DEFAULT_BOX: '#E5E5EC',
  ERROR: '#DC0000',
  BOX_BACKGROUND: '#F1F1F5',
  WHITE: '#FFFFFF',
};

export default colors;
